import { apiAxiosCMS } from 'services/api';
import { GeneralSettingsProps } from 'types/GeneralSettingsProps';

interface RespGetGeneralSettingsProps {
	isSuccess: boolean;
	data: GeneralSettingsProps[];
}

export async function getGeneralSettings(
	handleNotify: any,
	setIsOpenLoad: any,
	setMessage: any
) {
	const resp: RespGetGeneralSettingsProps = { isSuccess: false, data: [] };
	setIsOpenLoad(true);
	setMessage('Carregando informações');

	await apiAxiosCMS
		.get('config-images?withFile=true') // Cache de 5 minutos
		.then((res: any) => {
			resp.isSuccess = true;
			resp.data = res.data;
		})
		.catch((error: any) => {
			resp.isSuccess = false;
			resp.data = [];
			handleNotify(
				error?.message || 'Houve algum erro para buscar as configurações',
				'error'
			);
		});

	setIsOpenLoad(false);
	return resp;
}

interface RespSaveImgLoginOrMenu {
	isSuccess: boolean;
	data: null | GeneralSettingsProps;
}

export async function saveImgLoginOrMenu(
	id: string,
	typeImg: 'image_menu' | 'image_login',
	handleNotify: any
) {
	const resp: RespSaveImgLoginOrMenu = { isSuccess: false, data: null };
	await apiAxiosCMS
		.patch(`config-images/${typeImg}`, { file_id: id })
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res.data;
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.data = null;
			handleNotify(
				error?.message || 'Houve algum erro salvar a imagem',
				'error'
			);
		});

	return resp;
}
